/* src/app/result/finished/finished.component.scss */
.actions-summary {
  column-count: 2;
}
.left-content {
  display: block;
}
#next,
#finish {
  float: right;
  margin-bottom: 5%;
}
#back {
  float: left;
}
div.content-container {
}
div.text-container {
  text-align: left !important;
  left: 14%;
  position: absolute;
  width: 30%;
  top: 50%;
  transform: translate(0%, -50%);
  min-width: 542px;
}
h2.pagination {
  font-family: "Campton-Light";
  font-size: 20px;
  font-weight: normal;
  margin-bottom: 25px;
}
div.dos-and-donts-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  background-color: #3d3f47;
  width: 1180px;
  height: 620px;
  border-radius: 30px;
  margin: 0px 0 30px 0;
}
div.dos-and-donts-container h2.page-indicator {
  font-family: "Campton-Light";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 35px;
}
div.dos-and-donts-container h2 {
  font-family: "Campton-Semibold";
  font-style: normal;
  font-weight: 700;
  font-size: 34px;
  line-height: 46px;
  margin-bottom: 17px;
}
div.dos-and-donts-container.my-actions {
  height: 660px;
  display: inline-block;
  padding: 30px 50px 50px 50px;
  text-align: left;
}
div.dos-and-donts-container.my-actions p {
  margin-top: 10px;
}
div.dos-and-donts-container.my-actions.is-education .actions-summary {
  margin-top: 25px;
}
div.dos-and-donts-container.my-actions .actions-summary {
  height: 550px;
  margin-top: 10px;
}
.outer-container {
  margin-left: auto;
  margin-right: auto;
  width: 1180px;
  height: 720px;
}
div.dos-and-donts-text {
  width: 630px;
  text-align: left !important;
  margin-right: 100px;
  min-height: 525px;
}
div.dos-and-donts-comment {
  max-height: 460px;
  overflow-y: auto;
  margin-bottom: 35px;
  padding-right: 50px;
}
div.dos-and-donts-comment::-webkit-scrollbar-track {
  background-color: rgb(35, 37, 44);
  border-radius: 4px;
}
div.dos-and-donts-comment::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #ffffff !important;
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
div.dos-and-donts-text h1 {
  margin-bottom: 20px;
}
div.dos-and-donts-text p {
  margin-bottom: 17px;
}
div.dos-and-donts-text p:last-of-type {
  margin-bottom: 50px;
}
div.dos-and-donts-image {
  width: 380px;
  height: 520px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 30px;
}
div.dos-and-donts-image img {
  max-width: 100%;
}
div.dos-and-donts-text a:first-of-type {
  margin-right: 30px;
}
div.fullScreen.video-container {
  position: static;
  width: auto;
}
div.video-container {
  text-align: left !important;
  left: 56%;
  z-index: 2;
  position: absolute;
  width: 30%;
  top: 50%;
  transform: translate(0%, -50%);
  min-width: 542px;
}
div.text-container p {
  margin: 20px 0 40px 0;
}
div.text-container a.active {
  margin-right: 16px;
}
video {
  height: 100%;
  width: 100%;
  z-index: 1;
  background: #262933 !important;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  object-fit: cover;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.4);
}
.svg-bg {
  width: auto;
  height: auto;
  z-index: 2;
  background-size: contain;
  background-repeat: no-repeat;
  transition: 200ms;
  transition-timing-function: ease-in-out;
  -webkit-transition: 200ms;
  -webkit-transition-timing-function: ease-in-out;
  cursor: pointer;
  display: block;
  margin: 0 auto;
}
.svg-bg.play {
  background-image: url(/assets/img/play.svg);
}
.svg-bg.play:hover {
  background-image: url(/assets/img/play-color.svg);
}
.svg-bg.pause {
  background-image: url(/assets/img/pause.svg);
}
.svg-bg.pause:hover {
  background-image: url(/assets/img/pause-color.svg);
}
.svg-bg.backward {
  background-image: url(/assets/img/backward.svg);
}
.svg-bg.backward:hover {
  background-image: url(/assets/img/backward-color.svg);
}
.svg-bg.forward {
  background-image: url(/assets/img/forward.svg);
}
.svg-bg.forward:hover {
  background-image: url(/assets/img/forward-color.svg);
}
.controls-group,
.time-group {
  float: left;
  margin-top: 29px;
  margin-bottom: 22px;
}
.controls-group {
  width: 70%;
}
.time-group {
  width: 30%;
}
.controls-group button.svg-bg {
  height: 24px;
  width: 24px;
  float: left;
  margin-right: 32px;
}
.time-group div {
  float: right;
}
.time-group .current,
.time-group .max,
.time-group .separator {
  font-family: "Campton-book";
  line-height: 1.33;
  letter-spacing: 1.8px;
  opacity: 0.5;
}
.time-group .current {
  opacity: 1;
  font-weight: bold;
}
.time-group .separator {
  line-height: 1;
  margin: 0 8px;
  font-size: 1.33rem;
}
.progress-group {
  bottom: 0;
  height: 4px;
  width: 100%;
  background-color: transparent;
  position: absolute;
}
.progress-group .played {
  width: 0%;
  opacity: 1;
  height: 4px;
  background-color: #ffffff;
  float: left;
}
.progress-group .unplayed {
  width: 100%;
  height: 4px;
  opacity: 0.4;
  background-color: #ffffff;
  float: left;
}
.progress-group .current {
  width: 4px;
  opacity: 1;
  height: 14px;
  background-color: #ffffff;
  float: left;
  position: absolute;
  left: 0%;
  top: -5px;
}
.video-wrapper {
  min-height: 300px;
  width: 100%;
  position: relative;
  min-width: 482px;
  background: #262933 !important;
}
@media (max-width: 80em) {
  div.text-container {
    left: 4%;
    width: 40%;
    min-width: 542px;
  }
  div.video-container {
    left: 55%;
    width: 40%;
    min-width: 482px;
  }
}
.fullScreen .videobg {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #262933 !important;
}
.fullScreen .videobg-width {
  position: absolute;
  width: 100%;
  height: 100%;
  left: -9999px;
  right: -9999px;
  top: 0;
  margin: auto;
  background: #262933 !important;
}
.fullScreen .videobg-aspect {
  position: absolute;
  width: 100%;
  height: 0;
  top: -9999px;
  bottom: -9999px;
  margin: auto;
  padding-bottom: 56.25%;
  overflow: hidden;
  background: #262933 !important;
}
.fullScreen .videobg-make-height {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #262933 !important;
}
.fullScreen .videobg-hide-controls {
  box-sizing: content-box;
  position: relative;
  height: 102%;
  width: 102%;
  padding: 60px 89.7777px;
  top: -55px;
  left: -97.7777px;
  background: #262933 !important;
}
.fullScreen .videobg iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border: 0 none;
  background: #262933 !important;
}
.fullScreen .absolute-divs.controls-container .progress-group {
  width: 98%;
}
.fullScreen .absolute-divs.controls-container {
  position: absolute;
  bottom: 80px;
  width: 100%;
  z-index: 101;
  padding: 15px;
}
.grad {
  background-image:
    linear-gradient(
      46deg,
      #1f1f24,
      rgba(0, 0, 0, 0.5) 65%,
      rgba(0, 0, 0, 0));
}
.hide {
  display: none;
}
.play-next-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
.play-next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.helperImage {
  position: absolute;
  bottom: 50px;
  left: 32px;
  max-width: 500px;
}
/*# sourceMappingURL=finished.component.css.map */
